import Image from '@plone/volto/components/theme/Image/Image';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';

const ErrorTemplate = ({ imageSrc, imageAlt, title, description }) => {
  return (
    <Container className="my-6xh">
      <div className="row">
        <div className="col-12 col-md-5 col-lg-5 error-template__figure text-center">
          <Image
            src={imageSrc}
            alt={imageAlt}
            className="error-template__image col-8 col-md-12"
            role="presentation"
            aria-hidden="true"
          />
        </div>
        <div className="col-12 col-md-7 col-lg-7 mt-4xh mt-md-0">
          {title ? (
            <h1 className="text-bold text-pure-100 text-up-03 text-sm-up-05 mb-2 mb-sm-2x">
              {title}
            </h1>
          ) : null}
          {description ? (
            <div className="text-up-01 text-sm-up-02">{description}</div>
          ) : null}
        </div>
      </div>
    </Container>
  );
};

ErrorTemplate.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  title: PropTypes.node,
  description: PropTypes.node,
};

ErrorTemplate.defaultProps = {
  imageAlt: '',
  title: null,
  description: null,
};

export default ErrorTemplate;
